import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { TranslatePipe } from '@ngx-translate/core';
import { LocaleSwitcherService } from '@services/locale-switcher.service';

/**
 * Top-toolbar locale (site) filter switcher. Mirrors the legacy admin's "country" switcher: it does
 * not change the UI language, it scopes the Reservations and Customers lists to the selected site
 * locale (see {@link LocaleSwitcherService}).
 */
@Component({
  selector: 'app-locale-switcher',
  templateUrl: './locale-switcher.component.html',
  imports: [MatMenuModule, MatIconModule, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LocaleSwitcherComponent {
  readonly localeSwitcher = inject(LocaleSwitcherService);
}
